export * from './cedos.component';